let time_counter = 0;
let selector = '.bss-b2b-tax-ex-wrapper.bss-config-header';
const interval = setInterval(() => {
  let element = document.querySelector(selector);
  if (element) {
    console.log('Phần tử đã xuất hiện');
    clearInterval(interval);
    const taxWrapper = document.querySelector('.bss-b2b-tax-ex-wrapper.bss-config-header');
    const totalsContent = document.querySelector('.cart__blocks-content.js-contents-totals');

    if (taxWrapper && totalsContent) {
      totalsContent.insertAdjacentElement('afterend', taxWrapper);
    }
  } else {
    time_counter += 100;
    if (time_counter >= 10000) {
      clearInterval(interval);
    }
  }
}, 100);

function setMaxDateForInput(selector = "#bss-b2b-registration-form input[type='date']") {
  const today = new Date().toISOString().split('T')[0];
  const dateInput = document.querySelector(selector);
  if (dateInput) {
    dateInput.setAttribute('max', today);
  }
}

if (typeof BSS_B2B !== 'undefined' && BSS_B2B) {
  setTimeout(() => {
    setMaxDateForInput();
    const dateInput = document.querySelector('.bss-b2b-rf-field.field-date input');
    if (dateInput) {
      dateInput.setAttribute('placeholder', 'dd/mm/yyyy');
    }
  }, 3000);
}

const observer1 = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
      const modal = mutation.target;
      if (modal.hasAttribute('open')) {
        setTimeout(() => document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded')), 1000);
      }
    }
  });
});

const modals = document.getElementsByTagName('quick-add-modal');

Array.from(modals).forEach((modal) => {
  observer1.observe(modal, {
    attributes: true,
    attributeFilter: ['open'],
  });
});

const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== 'cart') {
  let timer = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector('.drawer.animate.active');

    if (footerPrice) {
      handleTEBox();
      clearInterval(interval);
    } else {
      timer += 100;
      if (timer >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let timer = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector('.bss-b2b-vat-input-wrapper');

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      timer += 100;
      if (timer >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector('.bss-b2b-translation-vat-form_header_text');
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector('.bss-b2b-translation-vat-form_subtitle_text');
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector('.bss-b2b-translation-vat-form_success_message'),
    document.querySelector('.bss-b2b-translation-vat-form_success_message_uk'),
    document.querySelector('.bss-b2b-translation-vat-form_success_message_abn'),
    document.querySelector('.bss-b2b-translation-vat-form_success_message_gst'),
    document.querySelector('.bss-b2b-translation-vat-form_success_message_us_ein'),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || '';
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || '';
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || '';
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || '';
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || '';
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector('.bss-b2b-translation-vat-form_error_message'),
    document.querySelector('.bss-b2b-translation-vat-form_error_message_uk'),
    document.querySelector('.bss-b2b-translation-vat-form_error_message_abn'),
    document.querySelector('.bss-b2b-translation-vat-form_error_message_gst'),
    document.querySelector('.bss-b2b-translation-vat-form_error_message_us_ein'),
    document.querySelector('.bss-b2b-translation-vat-form_validate_country_code_message'),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || '';
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || '';
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || '';
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || '';
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || '';
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || '';
          break;
      }
    }
  });
}

(function initBssQbTableThreshold() {
  const body = document.body;
  if (!body || !body.hasAttribute('data-bss-b2b-customer')) return;

  const thresholdCents = parseInt(body.getAttribute('data-bss-qb-hide-below') || '20500', 10);

  function parseMoneyToCents(text) {
    if (text == null) return 0;
    const digits = String(text).replace(/\D/g, '');
    return parseInt(digits, 10) || 0;
  }

  function getCartTotalCents() {
    const totalEl = document.querySelector('[bss-b2b-cart-total-price]');
    if (totalEl) return parseMoneyToCents(totalEl.textContent);
    return 0;
  }

  function isAmountBreakApplied() {
    return Boolean(
      document.querySelector(
        '#CartDrawer .bss-b2b-qty-table-row.qty-row-active, .main-cart__wrapper .bss-b2b-qty-table-row.qty-row-active, #main-cart-items .bss-b2b-qty-table-row.qty-row-active',
      ),
    );
  }

  function updateQbTableVisibility() {
    const total = getCartTotalCents();
    const underThreshold = total > 0 && total < thresholdCents;
    // Keep QB table visible when the 5% amount break is applied, even if total drops under threshold
    const shouldHide = underThreshold && !isAmountBreakApplied();
    body.classList.toggle('bss-hide-qb-under-threshold', shouldHide);
  }

  updateQbTableVisibility();

  const observer = new MutationObserver(() => {
    clearTimeout(window.__bssQbThresholdTimeout);
    window.__bssQbThresholdTimeout = setTimeout(updateQbTableVisibility, 100);
  });

  observer.observe(body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  document.addEventListener('cart:updated', updateQbTableVisibility);
  document.addEventListener('cart-drawer:updated', updateQbTableVisibility);
})();
